import React from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiSend } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="navbar-logo" style={{ marginBottom: 8 }}>
              <img src="/logo.png" alt="UzSport" style={{ height: 32, width: 'auto' }} />
              <span>UzSport</span>
            </Link>
            <p>{t('footer.desc')}</p>
          </div>

          <div>
            <h4 className="footer-title">{t('footer.explore')}</h4>
            <ul className="footer-links">
              <li><Link to="/events">{t('nav.events')}</Link></li>
              <li><Link to="/trainers">{t('nav.trainers')}</Link></li>
              <li><Link to="/gyms">{t('nav.gyms')}</Link></li>
              <li><Link to="/about">{t('nav.about')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">{t('footer.support')}</h4>
            <ul className="footer-links">
              <li><Link to="/faq">{t('nav.faq')}</Link></li>
              <li><Link to="/contact">{t('nav.contact')}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="footer-title">{t('footer.follow_us')}</h4>
            <ul className="footer-links">
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FiInstagram style={{ marginRight: 8, verticalAlign: 'middle' }} />Instagram</a></li>
              <li><a href="https://t.me" target="_blank" rel="noopener noreferrer"><FiSend style={{ marginRight: 8, verticalAlign: 'middle' }} />Telegram</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span>&copy; {new Date().getFullYear()} UzSport. {t('footer.all_rights')}</span>
          <span>{t('footer.made_with')}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
